const SCREEN_SIZE = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small'
};
const TYPOGRAPHY_SIZE = {
  GIGANTIC: 'gigantic',
  HUGE: 'huge',
  LARGE: 'large',
  BIGGER: 'bigger',
  BIG: 'big',
  NORMAL: 'normal',
  TINY: 'tiny'
};
const COLORS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DARK_GREY: 'darkGrey',
  GREY: 'grey',
  LIGHT_GREY: 'lightGrey',
  BLACK: 'black',
  WHITE: 'white'
};
const BOX_SHADOW_TYPES_VALUES = {
  LOW: 'LOW',
  HIGH: 'HIGH',
  NONE: 'NONE'
};
const BOOLEAN_VALUES = {
  FALSE: false,
  TRUE: true
};
const ALIGNMENT_OPTIONS = {
  CENTER: 'CENTER',
  START: 'START'
};
const SEMANTIC_TAG_VALUES = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
  P: 'p',
  SPAN: 'span'
};
const CONFIGURATION_TYPES = {
  COLOR: 'COLOR',
  TYPOGRAPHY: 'TYPOGRAPHY',
  NUMBER: 'NUMBER',
  BOX_SHADOW: 'BOX_SHADOW',
  BOOLEAN: 'BOOLEAN',
  ALIGNMENT: 'ALIGNMENT',
  RATIO: 'RATIO',
  SEMANTIC_TAG: 'SEMANTIC_TAG'
};

const baseConfiguration = {
  onTopCard: [{
    name: 'cardTitleColorTypeNormal',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeHover',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeActive',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderRadius',
    value: 4,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeNormal',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeHover',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeActive',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderColorTypeNormal',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorTypeHover',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorTypeActive',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeActive',
    value: BOX_SHADOW_TYPES_VALUES.HIGH,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeHover',
    value: BOX_SHADOW_TYPES_VALUES.HIGH,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'aspectRatioLarge',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioMedium',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioSmall',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'overlayColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'titleFontSizeLarge',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeMedium',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleAlignment',
    value: ALIGNMENT_OPTIONS.START,
    type: CONFIGURATION_TYPES.ALIGNMENT
  }, {
    name: 'showDateInSmallScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDateInMediumScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDateInLargeScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'dateColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'pipeColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'showAuthorInSmallScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showAuthorInMediumScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showAuthorInLargeScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'metadataAlignment',
    value: ALIGNMENT_OPTIONS.START,
    type: CONFIGURATION_TYPES.ALIGNMENT
  }, {
    name: 'metadataSemanticTag',
    value: SEMANTIC_TAG_VALUES.H4,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'metadataFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'authorColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'wrapperGapLarge',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'wrapperGapMedium',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'wrapperGapSmall',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapLarge',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapMedium',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapSmall',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapLarge',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapMedium',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapSmall',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'titleSemanticTag',
    value: SEMANTIC_TAG_VALUES.H3,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'showMainCategoryInLargeScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showMainCategoryInMediumScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showMainCategoryInSmallScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'mainCategorySemanticTag',
    value: SEMANTIC_TAG_VALUES.H4,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'mainCategoryFontSizeLarge',
    value: TYPOGRAPHY_SIZE.TINY,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'mainCategoryFontSizeMedium',
    value: TYPOGRAPHY_SIZE.TINY,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'mainCategoryFontSizeSmall',
    value: TYPOGRAPHY_SIZE.TINY,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'mainCategoryTextColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'mainCategoryBackgroundColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'mainCategoryVerticalGapLarge',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mainCategoryVerticalGapMedium',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mainCategoryVerticalGapSmall',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mainCategoryHorizontalGapLarge',
    value: 0.1,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mainCategoryHorizontalGapMedium',
    value: 0.1,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mainCategoryHorizontalGapSmall',
    value: 0.1,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mainCategoryAlignment',
    value: ALIGNMENT_OPTIONS.START,
    type: CONFIGURATION_TYPES.ALIGNMENT
  }],
  verticalCard: [{
    name: 'cardBackgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeNormal',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeHover',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeActive',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderRadius',
    value: 4,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeActive',
    value: BOX_SHADOW_TYPES_VALUES.HIGH,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeHover',
    value: BOX_SHADOW_TYPES_VALUES.HIGH,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'borderWidthTypeNormal',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeHover',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeActive',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderColorTypeNormal',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorTypeHover',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorTypeActive',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'showAuthorInSmallScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showAuthorInMediumScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showAuthorInLargeScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'metadataSemanticTag',
    value: SEMANTIC_TAG_VALUES.H4,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'metadataFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'authorColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'aspectRatioLarge',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioMedium',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioSmall',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'titleSemanticTag',
    value: SEMANTIC_TAG_VALUES.H3,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'titleFontSizeLarge',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeMedium',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'showDateInSmallScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDateInMediumScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDateInLargeScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'dateColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'pipeColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'wrapperGapLarge',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'wrapperGapMedium',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'wrapperGapSmall',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapLarge',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapMedium',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapSmall',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapLarge',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapMedium',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapSmall',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'showDescriptionInSmallScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDescriptionInMediumScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDescriptionInLargeScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'descriptionSemanticTag',
    value: SEMANTIC_TAG_VALUES.P,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'descriptionFontSize',
    value: TYPOGRAPHY_SIZE.NORMAL,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'descriptionColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'showMainCategoryInLargeScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showMainCategoryInMediumScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showMainCategoryInSmallScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'mainCategorySemanticTag',
    value: SEMANTIC_TAG_VALUES.H4,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'mainCategoryFontSizeLarge',
    value: TYPOGRAPHY_SIZE.TINY,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'mainCategoryFontSizeMedium',
    value: TYPOGRAPHY_SIZE.TINY,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'mainCategoryFontSizeSmall',
    value: TYPOGRAPHY_SIZE.TINY,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'mainCategoryTextColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'mainCategoryBackgroundColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'mainCategoryVerticalGapLarge',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mainCategoryVerticalGapMedium',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mainCategoryVerticalGapSmall',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mainCategoryHorizontalGapLarge',
    value: 0.1,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mainCategoryHorizontalGapMedium',
    value: 0.1,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mainCategoryHorizontalGapSmall',
    value: 0.1,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  horizontalCard: [{
    name: 'cardBackgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeNormal',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeHover',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeActive',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderRadius',
    value: 4,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeActive',
    value: BOX_SHADOW_TYPES_VALUES.HIGH,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeHover',
    value: BOX_SHADOW_TYPES_VALUES.HIGH,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'borderWidthTypeNormal',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeHover',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeActive',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderColorTypeNormal',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorTypeHover',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorTypeActive',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'aspectRatioLarge',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioMedium',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioSmall',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'shouldReverseImageAlignment',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'titleSemanticTag',
    value: SEMANTIC_TAG_VALUES.H3,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'titleFontSizeLarge',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeMedium',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'showDateInSmallScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDateInMediumScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDateInLargeScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'dateColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'pipeColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'showAuthorInSmallScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showAuthorInMediumScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showAuthorInLargeScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'metadataSemanticTag',
    value: SEMANTIC_TAG_VALUES.H5,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'metadataFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'authorColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'wrapperGapLarge',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'wrapperGapMedium',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'wrapperGapSmall',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapLarge',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapMedium',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapSmall',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapLarge',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapMedium',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapSmall',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'cardProportionsLarge',
    value: {
      x: 1,
      y: 2
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'cardProportionsMedium',
    value: {
      x: 1,
      y: 2
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'cardProportionsSmall',
    value: {
      x: 1,
      y: 2
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'showDescriptionInMediumScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDescriptionInLargeScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'descriptionSemanticTag',
    value: SEMANTIC_TAG_VALUES.P,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'descriptionFontSize',
    value: TYPOGRAPHY_SIZE.NORMAL,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'descriptionColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'showMainCategoryInLargeScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showMainCategoryInMediumScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showMainCategoryInSmallScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'mainCategorySemanticTag',
    value: SEMANTIC_TAG_VALUES.H4,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'mainCategoryFontSizeLarge',
    value: TYPOGRAPHY_SIZE.TINY,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'mainCategoryFontSizeMedium',
    value: TYPOGRAPHY_SIZE.TINY,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'mainCategoryFontSizeSmall',
    value: TYPOGRAPHY_SIZE.TINY,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'mainCategoryTextColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'mainCategoryBackgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'mainCategoryVerticalGapLarge',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mainCategoryVerticalGapMedium',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mainCategoryVerticalGapSmall',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mainCategoryHorizontalGapLarge',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mainCategoryHorizontalGapMedium',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mainCategoryHorizontalGapSmall',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  decorationLine: [{
    name: 'cardDecorationColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  sectionHeader: [{
    name: 'titleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'titleBackgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'squareColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'showSquare',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showBorderTop',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showArrow',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showMiddleHorizontalLine',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showStrikeThrowHorizontalLine',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'strikeThrowHorizontalLineColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'idleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'middleHorizontalLineColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'arrowColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'visitedStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderTopColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderTopWidth',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeVerticalGap',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumVerticalGap',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallVerticalGap',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeHorizontalGap',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeWrapperGap',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumWrapperGap',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallWrapperGap',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  listWithHeading: [{
    name: 'titleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'backgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderWidth',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderRadius',
    value: 4,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeActive',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeHover',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }],
  list: [{
    name: 'backgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderWidth',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderRadius',
    value: 4,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeActive',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeHover',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }],
  listItem: [{
    name: 'borderColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'linkColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'linkHoverColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  button: [{
    name: 'backgroundColorNormal',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'backgroundColorHover',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'backgroundColorActive',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColorNormal',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColorHover',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColorActive',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderRadius',
    value: 4,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthNormal',
    value: 2,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthHover',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthActive',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderColorNormal',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorHover',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorActive',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.NONE,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeActive',
    value: BOX_SHADOW_TYPES_VALUES.NONE,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeHover',
    value: BOX_SHADOW_TYPES_VALUES.NONE,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }],
  main: [{
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  mainPostPage: [{
    name: 'backgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  primaryHeader: [{
    name: 'backgroundColor',
    value: COLORS.BLACK,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }],
  primaryLinks: [{
    name: 'idleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'visitedStateColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeBorderBottom',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverOtherLinksColors',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  editions: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  editionsMenu: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'menuBackgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'linkColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }],
  ctaButton: [{
    name: 'backgroundColorNormal',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColorNormal',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorNormal',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'backgroundColorHover',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColorHover',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorHover',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'backgroundColorActive',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColorActive',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorActive',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderRadius',
    value: 4,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  footer: [{
    name: 'backgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderTopColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'separatorColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  footerLinksSection: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'idleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeStateColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'visitedStateColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  footerMobileStores: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  secondaryHeader: [{
    name: 'backgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }],
  secondaryLink: [{
    name: 'idleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverOtherLinksColors',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'fontSize',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }],
  moreLinks: [{
    name: 'titleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'menuBackgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'linkColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'fontSize',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }],
  menuIcon: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  ampCloseMenuIcon: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  menuLinks: [{
    name: 'backgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'dividerColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  menuLink: [{
    name: 'idleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'activeStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  menuSubLink: [{
    name: 'idleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  footerSocialLinks: [{
    name: 'titleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'circleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  bottomFooterBar: [{
    name: 'backgroundColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  errorPage: [{
    name: 'titleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'buttonColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'buttonBackgroundColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  articleTitle: [{
    name: 'titleColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'metaDataColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  imageWithFigcaptionWrapper: [{
    name: 'figcaptionTextColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  imageWrapper: [{
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  articleParagraph: [{
    name: 'linkColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  quote: [{
    name: 'borderColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'citeColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'iconColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  divider: [{
    name: 'color',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  mmPlayer: [{
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  iframeEmbed: [{
    name: 'backgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  iframe: [{
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  postMainContent: [{
    name: 'backgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  streamable: [{
    name: 'backgroundColor',
    value: COLORS.BLACK,
    type: CONFIGURATION_TYPES.COLOR
  }],
  listItemTitle: [{
    name: 'titleColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'numberColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  articleShareButton: [{
    name: 'buttonBackgroundColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'buttonHoverColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  copyLinkButton: [{
    name: 'color',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  playIcon: [{
    name: 'backgroundColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'triangleColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }],
  mobileTopBar: [{
    name: 'backgroundColor',
    value: COLORS.BLACK,
    type: CONFIGURATION_TYPES.COLOR
  }],
  postRecommendationsHeader: [{
    name: 'color',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  recommendationCardPlaceHolder: [{
    name: 'backgroundColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  sponsor: [{
    name: 'dividerColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'textColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  authorPage: [{
    name: 'titleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'metaDataColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'color',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  authorImage: [{
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }],
  authorPageSocial: [{
    name: 'backgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  authorTopGradient: [{
    name: 'color',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  sixSix: [{
    name: 'showDescriptionInSmallScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDescriptionInMediumScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDescriptionInLargeScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showAuthorInSmallScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showAuthorInMediumScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showAuthorInLargeScreen',
    value: BOOLEAN_VALUES.FALSE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }],
  oneTwoOnTopFullWidth: [{
    name: 'mainCardTitleFontSizeLarge',
    value: TYPOGRAPHY_SIZE.HUGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'mainCardTitleFontSizeMedium',
    value: TYPOGRAPHY_SIZE.HUGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'mainCardTitleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'secondaryCardsTitleFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'secondaryCardsTitleFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'secondaryCardsTitleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'secondaryCardsMetadataFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'secondaryCardsMetadataFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'secondaryCardsMetadataFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'largeVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'aspectRatioSmallForFirstCard',
    value: {
      x: 16,
      y: 9
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'authorColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'insideCardSmallHorizontalGap',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'insideCardMediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'insideCardLargeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'aspectRatioSmall',
    value: {
      x: 4,
      y: 3
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'titleSemanticTag',
    value: SEMANTIC_TAG_VALUES.H2,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }],
  twoOneTwoArticleList: [{
    name: 'largeVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'minorCardsRatioLarge',
    value: {
      x: 1,
      y: 1
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'minorCardsRatioMedium',
    value: {
      x: 1,
      y: 1
    },
    type: CONFIGURATION_TYPES.RATIO
  }],
  oneThreeOTC: [{
    name: 'largeVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  twoTwoVC: [{
    name: 'largeVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  threeThreeVC: [{
    name: 'largeVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'titleFontSizeLarge',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeMedium',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }],
  sixHC: [{
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  sixHCForTwoThirds: [{
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'aspectRatioLarge',
    value: {
      x: 4,
      y: 3
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioMedium',
    value: {
      x: 4,
      y: 3
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioSmall',
    value: {
      x: 4,
      y: 3
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'titleFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleSemanticTag',
    value: SEMANTIC_TAG_VALUES.H4,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'metadataSemanticTag',
    value: SEMANTIC_TAG_VALUES.H5,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'showDescriptionInLargeScreen',
    value: true,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDescriptionInMediumScreen',
    value: true,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDescriptionInSmallScreen',
    value: false,
    type: CONFIGURATION_TYPES.BOOLEAN
  }],
  fourVC: [{
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  headlineCard: [{
    name: 'cardTitleColorTypeNormal',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeHover',
    value: COLORS.BLACK,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'cardTitleColorTypeActive',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'titleFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'pipeColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'showAuthorInSmallScreen',
    value: BOOLEAN_VALUES.TRUE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showAuthorInMediumScreen',
    value: BOOLEAN_VALUES.TRUE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showAuthorInLargeScreen',
    value: BOOLEAN_VALUES.TRUE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDateInSmallScreen',
    value: BOOLEAN_VALUES.TRUE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDateInMediumScreen',
    value: BOOLEAN_VALUES.TRUE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDateInLargeScreen',
    value: BOOLEAN_VALUES.TRUE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'dateColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'metadataSemanticTag',
    value: SEMANTIC_TAG_VALUES.H5,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'metadataFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'authorColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'horizontalGapLarge',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapMedium',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapSmall',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'titleSemanticTag',
    value: SEMANTIC_TAG_VALUES.H4,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }],
  fourHeadlineCards: [{
    name: 'borderRadius',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeNormal',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeHover',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeActive',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderColorTypeNormal',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorTypeHover',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorTypeActive',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.NONE,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeActive',
    value: BOX_SHADOW_TYPES_VALUES.NONE,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeHover',
    value: BOX_SHADOW_TYPES_VALUES.NONE,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'wrapperGapLarge',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'wrapperGapMedium',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'wrapperGapSmall',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'backgroundColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'dividerWidth',
    value: 1,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'diverColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'dividerGapInSmallScreen',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'dividerGapInMediumScreen',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'dividerGapInLargeScreen',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'showDivider',
    value: BOOLEAN_VALUES.TRUE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }],
  announcementCard: [{
    name: 'titleColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'titleFontSizeLarge',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeMedium',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleSemanticTag',
    value: SEMANTIC_TAG_VALUES.H2,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'subHeadlineColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'subHeadlineFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'subHeadlineFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'subHeadlineFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'subHeadlineSemanticTag',
    value: SEMANTIC_TAG_VALUES.H4,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'wrapperGapLarge',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'wrapperGapMedium',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'wrapperGapSmall',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapLarge',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapMedium',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapSmall',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeNormal',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeHover',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderWidthTypeActive',
    value: 0,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'borderColorTypeNormal',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorTypeHover',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'borderColorTypeActive',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'boxShadowTypeNormal',
    value: BOX_SHADOW_TYPES_VALUES.NONE,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeActive',
    value: BOX_SHADOW_TYPES_VALUES.NONE,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'boxShadowTypeHover',
    value: BOX_SHADOW_TYPES_VALUES.NONE,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'aspectRatioLarge',
    value: {
      x: 27,
      y: 2
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioMedium',
    value: {
      x: 9,
      y: 1
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioSmall',
    value: {
      x: 9,
      y: 2
    },
    type: CONFIGURATION_TYPES.RATIO
  }],
  oneTwoTwoOTC: [{
    name: 'largeVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  oneOTCFourVC: [{
    name: 'largeVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'authorColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  oneOTCFourHLC: [{
    name: 'largeVerticalGap',
    value: 1,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumVerticalGap',
    value: 1,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 1,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'dividerWidth',
    value: 1,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'diverColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'showDivider',
    value: BOOLEAN_VALUES.TRUE,
    type: CONFIGURATION_TYPES.BOOLEAN
  }],
  threeHCOneOTC: [{
    name: 'largeVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'titleFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'aspectRatioLarge',
    value: {
      x: 4,
      y: 3
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioSmall',
    value: {
      x: 1,
      y: 1
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'showDescriptionInMediumScreen',
    value: true,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'authorColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'insideCardSmallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  fourVCOneOTC: [{
    name: 'largeVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumVerticalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'authorColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'primaryTitleFontSizeLarge',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'primaryTitleFontSizeMedium',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'primaryTitleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'primaryMetadataFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'primaryMetadataFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'primaryMetadataFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'primaryHorizontalGapLarge',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'primaryHorizontalGapMedium',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'primaryHorizontalGapSmall',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'aspectRatioSmall',
    value: {
      x: 4,
      y: 3
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'secondaryTitleFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'secondaryTitleFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'secondaryTitleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'secondaryMetadataFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'secondaryMetadataFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'secondaryMetadataFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'secondaryHorizontalGapLarge',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'secondaryHorizontalGapMedium',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'secondaryHorizontalGapSmall',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  tenHC: [{
    name: 'largeHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'mediumHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'smallHorizontalGap',
    value: 0.5,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  tenHCForOneThird: [{
    name: 'aspectRatioLarge',
    value: {
      x: 1,
      y: 1
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioMedium',
    value: {
      x: 4,
      y: 3
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'aspectRatioSmall',
    value: {
      x: 1,
      y: 1
    },
    type: CONFIGURATION_TYPES.RATIO
  }, {
    name: 'titleFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'pipeColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleSemanticTag',
    value: SEMANTIC_TAG_VALUES.H4,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'metadataSemanticTag',
    value: SEMANTIC_TAG_VALUES.H5,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'showDescriptionInLargeScreen',
    value: false,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDescriptionInMediumScreen',
    value: false,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'showDescriptionInSmallScreen',
    value: false,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'verticalGapLarge',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapMedium',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapSmall',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapLarge',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapMedium',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'horizontalGapSmall',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  oneOTCThreeHC: [{
    name: 'titleFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'titleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'OTCTitleFontSizeSmall',
    value: TYPOGRAPHY_SIZE.LARGE,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'metadataFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'authorColor',
    value: COLORS.GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'showDescriptionInMediumScreen',
    value: false,
    type: CONFIGURATION_TYPES.BOOLEAN
  }, {
    name: 'insideCardSmallHorizontalGap',
    value: 0.25,
    type: CONFIGURATION_TYPES.NUMBER
  }],
  headerWithSubMenus: [{
    name: 'firstRowBackgroundColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'secondRowBackgroundColor',
    value: COLORS.SECONDARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'firstRowHeightInSmallScreen',
    value: 3,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'firstRowHeightInMediumScreen',
    value: 3,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'firstRowHeightInLargeScreen',
    value: 4,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'secondRowHeightInSmallScreen',
    value: 2,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'secondRowHeightInMediumScreen',
    value: 2,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'logoHeightInSmallScreen',
    value: 1.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'logoHeightInMediumScreen',
    value: 1.5,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'logoHeightInLargeScreen',
    value: 2,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'linkSemanticTag',
    value: SEMANTIC_TAG_VALUES.H4,
    type: CONFIGURATION_TYPES.SEMANTIC_TAG
  }, {
    name: 'linkFontSizeLarge',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'linkFontSizeMedium',
    value: TYPOGRAPHY_SIZE.BIGGER,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'linkFontSizeSmall',
    value: TYPOGRAPHY_SIZE.BIG,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }, {
    name: 'linkColorTypeNormal',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'linkColorTypeHover',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'linkColorTypeActive',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'linkDropdownIconColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'socialMediaIconColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'editionsIconColor',
    value: COLORS.WHITE,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'verticalGapInSmallScreen',
    value: 0.75,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapInMediumScreen',
    value: 0.75,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'verticalGapInLargeScreen',
    value: 1,
    type: CONFIGURATION_TYPES.NUMBER
  }, {
    name: 'boxShadow',
    value: BOX_SHADOW_TYPES_VALUES.LOW,
    type: CONFIGURATION_TYPES.BOX_SHADOW
  }, {
    name: 'activeStateColor',
    value: COLORS.PRIMARY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'hoverStateColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'editionsSeparatorColor',
    value: COLORS.LIGHT_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'editionsMenuBackgroundColor',
    value: COLORS.BLACK,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'subMenuLinksBackgroundColor',
    value: COLORS.BLACK,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'subMenuLinksSecondLevelBackgroundColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  fixedNav: [{
    name: 'linkBackgroundColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }, {
    name: 'subMenuLinksBackgroundColor',
    value: COLORS.DARK_GREY,
    type: CONFIGURATION_TYPES.COLOR
  }],
  subMenu: [{
    name: 'innerMenuFontSizeLarge',
    value: TYPOGRAPHY_SIZE.NORMAL,
    type: CONFIGURATION_TYPES.TYPOGRAPHY
  }]
};

class ConfigurationBuilder {
  // eslint-disable-next-line no-useless-constructor,no-empty-function
  constructor(overrides = { ...baseConfiguration
  }) {
    this.overrides = overrides;
  }

  replaceValueInElement(componentName, propName, value) {
    return this.overrides[componentName].map(element => {
      if (element.name === propName) {
        return { ...element,
          value
        };
      }

      return element;
    });
  }

  overrideColor(componentName, propName, color) {
    this.overrides[componentName] = this.replaceValueInElement(componentName, propName, color);
    return this;
  }

  overrideNumber(componentName, propName, number) {
    this.overrides[componentName] = this.replaceValueInElement(componentName, propName, number);
    return this;
  }

  overrideBoxShadow(componentName, propName, boxShadow) {
    this.overrides[componentName] = this.replaceValueInElement(componentName, propName, boxShadow);
    return this;
  }

  overrideBoolean(componentName, propName, boolean) {
    this.overrides[componentName] = this.replaceValueInElement(componentName, propName, boolean);
    return this;
  }

  overrideRatio(componentName, propName, ratio) {
    this.overrides[componentName] = this.replaceValueInElement(componentName, propName, ratio);
    return this;
  }

  overrideTypography(componentName, propName, typography) {
    this.overrides[componentName] = this.replaceValueInElement(componentName, propName, typography);
    return this;
  }

  build() {
    return { ...this.overrides
    };
  }

}

const configurationBuilder = () => new ConfigurationBuilder();

const configuration = configurationBuilder().overrideColor('verticalCard', 'cardTextColorTypeNormal', 'primary').overrideColor('verticalCard', 'cardTextColorTypeHover', 'primary').overrideColor('verticalCard', 'cardTextColorTypeActive', 'primary').overrideColor('horizontalCard', 'cardTextColorTypeNormal', 'primary').overrideColor('horizontalCard', 'cardTextColorTypeHover', 'primary').overrideColor('horizontalCard', 'cardTextColorTypeActive', 'primary').overrideColor('onTopCard', 'overlayColor', 'black').overrideColor('decorationLine', 'cardDecorationColor', 'primary').overrideColor('sectionHeader', 'titleColor', 'secondary').overrideColor('sectionHeader', 'idleColor', 'secondary').overrideColor('sectionHeader', 'hoverStateColor', 'secondary').overrideColor('sectionHeader', 'activeStateColor', 'secondary').overrideColor('listWithHeading', 'titleColor', 'secondary').overrideColor('listItem', 'linkColor', 'primary').overrideColor('listItem', 'linkHoverColor', 'secondary').overrideColor('primaryHeader', 'backgroundColor', 'primary').overrideColor('primaryLinks', 'hoverStateColor', 'white').overrideColor('primaryLinks', 'activeStateColor', 'white').overrideColor('primaryLinks', 'activeBorderBottom', 'white').overrideColor('primaryLinks', 'hoverOtherLinksColors', 'grey').overrideColor('editionsMenu', 'menuBackgroundColor', 'primary').overrideColor('footer', 'separatorColor', 'primary').overrideColor('secondaryLink', 'hoverStateColor', 'white').overrideColor('secondaryLink', 'hoverOtherLinksColors', 'grey').overrideColor('moreLinks', 'hoverColor', 'white').overrideColor('mobileTopBar', 'backgroundColor', 'primary').overrideColor('button', 'backgroundColorNormal', COLORS.PRIMARY).overrideColor('button', 'textColorNormal', COLORS.WHITE).overrideNumber('button', 'borderRadius', 4).overrideNumber('button', 'borderWidthNormal', 0).overrideBoxShadow('button', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('button', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.HIGH).overrideBoxShadow('button', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.LOW).build();

const colors = {
  [COLORS.PRIMARY]: '#1493FF',
  [COLORS.SECONDARY]: '#1F375B',
  [COLORS.DARK_GREY]: '#445058',
  [COLORS.GREY]: '#B9C4CB',
  [COLORS.LIGHT_GREY]: '#F0F3F8',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const fonts = [{
  provider: 'custom',
  family: 'proxima-nova',
  variants: ['400', '600', '700'],
  stylesheetUrl: 'https://use.typekit.net/nxl2plh.css'
}];

const fontSizeMap = {
  [TYPOGRAPHY_SIZE.GIGANTIC]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 40,
      [SCREEN_SIZE.MEDIUM]: 32,
      [SCREEN_SIZE.SMALL]: 24
    },
    fontWeight: 700,
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, sans-serif'
  },
  [TYPOGRAPHY_SIZE.HUGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 32,
      [SCREEN_SIZE.MEDIUM]: 24,
      [SCREEN_SIZE.SMALL]: 20
    },
    fontWeight: 700,
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, sans-serif'
  },
  [TYPOGRAPHY_SIZE.LARGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 20,
      [SCREEN_SIZE.MEDIUM]: 20,
      [SCREEN_SIZE.SMALL]: 16
    },
    fontWeight: 600,
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIGGER]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 600,
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIG]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 14,
      [SCREEN_SIZE.MEDIUM]: 14,
      [SCREEN_SIZE.SMALL]: 12
    },
    fontWeight: 400,
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, sans-serif'
  },
  [TYPOGRAPHY_SIZE.TINY]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 12,
      [SCREEN_SIZE.MEDIUM]: 12,
      [SCREEN_SIZE.SMALL]: 10
    },
    fontWeight: 400,
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, sans-serif'
  },
  [TYPOGRAPHY_SIZE.NORMAL]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 400,
    fontFamily: 'proxima-nova',
    defaultFontFamily: 'Arial, sans-serif'
  }
};

const palette = {
  colors,
  fonts,
  fontSizeMap
};

const configuration$1 = configurationBuilder().overrideNumber('onTopCard', 'borderWidthTypeNormal', 2).overrideNumber('onTopCard', 'borderWidthTypeHover', 2).overrideNumber('onTopCard', 'borderWidthTypeActive', 2).overrideNumber('verticalCard', 'borderWidthTypeNormal', 2).overrideNumber('verticalCard', 'borderWidthTypeHover', 2).overrideNumber('horizontalCard', 'borderWidthTypeNormal', 2).overrideNumber('horizontalCard', 'borderWidthTypeHover', 2).overrideNumber('horizontalCard', 'borderWidthTypeActive', 2).overrideNumber('list', 'borderWidth', 2).overrideNumber('listWithHeading', 'borderWidth', 2).overrideColor('list', 'borderColor', COLORS.LIGHT_GREY).overrideColor('listWithHeading', 'borderColor', COLORS.LIGHT_GREY).overrideColor('horizontalCard', 'borderColorTypeNormal', COLORS.LIGHT_GREY).overrideColor('horizontalCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideColor('horizontalCard', 'borderColorTypeActive', COLORS.LIGHT_GREY).overrideColor('verticalCard', 'borderColorTypeNormal', COLORS.LIGHT_GREY).overrideColor('verticalCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideColor('verticalCard', 'borderColorTypeActive', COLORS.LIGHT_GREY).overrideColor('onTopCard', 'borderColorTypeNormal', COLORS.LIGHT_GREY).overrideColor('onTopCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideColor('onTopCard', 'borderColorTypeActive', COLORS.LIGHT_GREY).overrideColor('decorationLine', 'cardDecorationColor', COLORS.WHITE).overrideColor('main', 'backgroundColor', COLORS.WHITE).overrideColor('sectionHeader', 'titleBackgroundColor', COLORS.WHITE).overrideColor('verticalCard', 'cardTextColorTypeHover', COLORS.BLACK).overrideColor('horizontalCard', 'cardTextColorTypeHover', COLORS.BLACK).overrideColor('horizontalCard', 'cardTextColorTypeActive', COLORS.DARK_GREY).overrideBoxShadow('onTopCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('onTopCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('onTopCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('verticalCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('verticalCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('verticalCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('horizontalCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('horizontalCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('horizontalCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('listWithHeading', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('listWithHeading', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('listWithHeading', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('list', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('list', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('list', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoolean('onTopCard', 'showAuthorInLargeScreen', true).overrideBoolean('onTopCard', 'showAuthorInMediumScreen', true).overrideBoolean('onTopCard', 'showAuthorInSmallScreen', true).overrideBoolean('horizontalCard', 'showAuthorInLargeScreen', true).overrideBoolean('horizontalCard', 'showAuthorInMediumScreen', true).overrideBoolean('horizontalCard', 'showAuthorInSmallScreen', true).overrideBoolean('verticalCard', 'showAuthorInLargeScreen', true).overrideBoolean('verticalCard', 'showAuthorInMediumScreen', true).overrideBoolean('verticalCard', 'showAuthorInSmallScreen', true).overrideBoolean('onTopCard', 'showDateInLargeScreen', true).overrideBoolean('onTopCard', 'showDateInMediumScreen', true).overrideBoolean('onTopCard', 'showDateInSmallScreen', true).overrideBoolean('horizontalCard', 'showDateInLargeScreen', true).overrideBoolean('horizontalCard', 'showDateInMediumScreen', true).overrideBoolean('horizontalCard', 'showDateInSmallScreen', true).overrideBoolean('verticalCard', 'showDateInLargeScreen', true).overrideBoolean('verticalCard', 'showDateInMediumScreen', true).overrideBoolean('verticalCard', 'showDateInSmallScreen', true).overrideBoolean('sectionHeader', 'showMiddleHorizontalLine', true).overrideColor('sectionHeader', 'middleHorizontalLineColor', COLORS.LIGHT_GREY).overrideNumber('sectionHeader', 'largeVerticalGap', 1).overrideNumber('sectionHeader', 'mediumVerticalGap', 1).overrideNumber('sectionHeader', 'smallVerticalGap', 0.5).build();

const colors$1 = {
  [COLORS.PRIMARY]: '#FF9900',
  [COLORS.SECONDARY]: '#1B1B1B',
  [COLORS.DARK_GREY]: '#444444',
  [COLORS.GREY]: '#A1A1A1',
  [COLORS.LIGHT_GREY]: '#F3F3F3',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const fonts$1 = [{
  provider: 'google',
  family: 'Roboto',
  variants: ['400', '600', '700']
}];

const fontSizeMap$1 = {
  [TYPOGRAPHY_SIZE.GIGANTIC]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 40,
      [SCREEN_SIZE.MEDIUM]: 32,
      [SCREEN_SIZE.SMALL]: 24
    },
    fontWeight: 700,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.HUGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 32,
      [SCREEN_SIZE.MEDIUM]: 24,
      [SCREEN_SIZE.SMALL]: 20
    },
    fontWeight: 700,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.LARGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 20,
      [SCREEN_SIZE.MEDIUM]: 20,
      [SCREEN_SIZE.SMALL]: 16
    },
    fontWeight: 600,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIGGER]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 600,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIG]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 14,
      [SCREEN_SIZE.MEDIUM]: 14,
      [SCREEN_SIZE.SMALL]: 12
    },
    fontWeight: 400,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.TINY]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 12,
      [SCREEN_SIZE.MEDIUM]: 12,
      [SCREEN_SIZE.SMALL]: 10
    },
    fontWeight: 400,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.NORMAL]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 400,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  }
};

const palette$1 = {
  colors: colors$1,
  fonts: fonts$1,
  fontSizeMap: fontSizeMap$1
};

const configuration$2 = configurationBuilder().overrideColor('primaryHeader', 'backgroundColor', 'primary').overrideColor('primaryLinks', 'hoverStateColor', 'grey').overrideColor('primaryLinks', 'activeStateColor', 'white').overrideColor('primaryLinks', 'activeBorderBottom', 'white').overrideColor('footer', 'separatorColor', 'primary').overrideColor('secondaryLink', 'hoverStateColor', 'grey').overrideColor('secondaryLink', 'activeStateColor', 'white').overrideColor('bottomFooterBar', 'backgroundColor', 'primary').overrideColor('mobileTopBar', 'backgroundColor', 'primary').build();

const colors$2 = {
  [COLORS.PRIMARY]: '#6A1B9A',
  [COLORS.SECONDARY]: '#38006B',
  [COLORS.DARK_GREY]: '#445058',
  [COLORS.GREY]: '#9E9E9E',
  [COLORS.LIGHT_GREY]: '#F5F5F5',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const fonts$2 = [{
  provider: 'google',
  family: 'Roboto',
  variants: ['400', '600', '700']
}];

const fontSizeMap$2 = {
  [TYPOGRAPHY_SIZE.GIGANTIC]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 40,
      [SCREEN_SIZE.MEDIUM]: 32,
      [SCREEN_SIZE.SMALL]: 24
    },
    fontWeight: 700,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.HUGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 32,
      [SCREEN_SIZE.MEDIUM]: 24,
      [SCREEN_SIZE.SMALL]: 20
    },
    fontWeight: 700,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.LARGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 20,
      [SCREEN_SIZE.MEDIUM]: 20,
      [SCREEN_SIZE.SMALL]: 16
    },
    fontWeight: 600,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIGGER]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 600,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIG]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 14,
      [SCREEN_SIZE.MEDIUM]: 14,
      [SCREEN_SIZE.SMALL]: 12
    },
    fontWeight: 400,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.TINY]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 12,
      [SCREEN_SIZE.MEDIUM]: 12,
      [SCREEN_SIZE.SMALL]: 10
    },
    fontWeight: 400,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.NORMAL]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 400,
    fontFamily: 'Roboto',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  }
};

const palette$2 = {
  colors: colors$2,
  fonts: fonts$2,
  fontSizeMap: fontSizeMap$2
};

const configuration$3 = configurationBuilder().overrideColor('moreLinks', 'hoverColor', 'grey').overrideColor('moreLinks', 'activeColor', 'secondary').overrideColor('menuIcon', 'color', 'primary').overrideColor('menuLinks', 'backgroundColor', 'black').overrideColor('menuLink', 'activeStateColor', 'secondary').overrideColor('footerSocialLinks', 'circleColor', 'secondary').overrideColor('bottomFooterBar', 'backgroundColor', 'black').overrideColor('articleTitle', 'titleColor', 'primary').overrideColor('mobileTopBar', 'backgroundColor', 'primary').overrideColor('primaryHeader', 'backgroundColor', 'white').overrideColor('secondaryHeader', 'backgroundColor', 'darkGrey').overrideColor('primaryLinks', 'idleColor', 'darkGrey').overrideColor('primaryLinks', 'visitedStateColor', 'darkGrey').overrideColor('primaryLinks', 'hoverOtherLinksColors', 'darkGrey').overrideColor('secondaryLink', 'hoverStateColor', 'secondary').overrideColor('secondaryLink', 'activeStateColor', 'secondary').overrideColor('secondaryLink', 'hoverOtherLinksColors', 'lightGrey').overrideColor('moreLinks', 'menuBackgroundColor', 'darkGrey').overrideColor('moreLinks', 'hoverColor', 'secondary').overrideColor('editions', 'color', 'darkGrey').overrideColor('editionsMenu', 'color', 'darkGrey').overrideColor('editionsMenu', 'menuBackgroundColor', 'white').overrideColor('editionsMenu', 'hoverColor', 'primary').overrideColor('editionsMenu', 'linkColor', 'darkGrey').overrideColor('editionsMenu', 'activeColor', 'primary').overrideColor('footer', 'backgroundColor', 'darkGrey').overrideColor('footer', 'borderTopColor', 'secondary').overrideColor('footer', 'separatorColor', 'secondary').overrideColor('footerLinksSection', 'hoverStateColor', 'secondary').overrideColor('decorationLine', 'cardDecorationColor', 'secondary').overrideColor('articleShareButton', 'buttonBackgroundColor', 'secondary').overrideNumber('onTopCard', 'borderRadius', 0).overrideNumber('verticalCard', 'borderRadius', 0).overrideNumber('horizontalCard', 'borderRadius', 0).overrideNumber('ctaButton', 'borderRadius', 0).overrideNumber('list', 'borderRadius', 0).overrideNumber('listWithHeading', 'borderRadius', 0).overrideColor('onTopCard', 'overlayColor', 'black').overrideColor('button', 'backgroundColorNormal', COLORS.PRIMARY).overrideColor('button', 'textColorNormal', COLORS.WHITE).overrideNumber('button', 'borderRadius', 20).overrideNumber('button', 'borderWidthNormal', 0).overrideBoxShadow('button', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('button', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.HIGH).overrideBoxShadow('button', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoolean('onTopCard', 'showAuthorInLargeScreen', true).overrideBoolean('onTopCard', 'showAuthorInMediumScreen', true).overrideBoolean('onTopCard', 'showAuthorInSmallScreen', true).overrideBoolean('verticalCard', 'showAuthorInLargeScreen', true).overrideBoolean('verticalCard', 'showAuthorInMediumScreen', true).overrideBoolean('verticalCard', 'showAuthorInSmallScreen', true).overrideBoolean('horizontalCard', 'showAuthorInLargeScreen', true).overrideBoolean('horizontalCard', 'showAuthorInMediumScreen', true).overrideBoolean('horizontalCard', 'showAuthorInSmallScreen', true).overrideBoolean('sixSix', 'showDescriptionInMediumScreen', true).overrideBoolean('sixSix', 'showDescriptionInLargeScreen', true).overrideBoolean('sectionHeader', 'showSquare', true).overrideColor('sectionHeader', 'squareColor', COLORS.SECONDARY).build();

const colors$3 = {
  [COLORS.PRIMARY]: '#020286',
  [COLORS.SECONDARY]: '#1CB1E5',
  [COLORS.DARK_GREY]: '#212121',
  [COLORS.GREY]: '#9E9E9E',
  [COLORS.LIGHT_GREY]: '#F5F5F5',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const fonts$3 = [{
  provider: 'google',
  family: 'Montserrat',
  variants: ['600', '700']
}, {
  provider: 'google',
  family: 'Roboto Slab',
  variants: ['400']
}];

const fontSizeMap$3 = {
  [TYPOGRAPHY_SIZE.GIGANTIC]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 40,
      [SCREEN_SIZE.MEDIUM]: 32,
      [SCREEN_SIZE.SMALL]: 24
    },
    fontWeight: 700,
    fontFamily: 'Montserrat',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.HUGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 32,
      [SCREEN_SIZE.MEDIUM]: 24,
      [SCREEN_SIZE.SMALL]: 20
    },
    fontWeight: 700,
    fontFamily: 'Montserrat',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.LARGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 20,
      [SCREEN_SIZE.MEDIUM]: 20,
      [SCREEN_SIZE.SMALL]: 16
    },
    fontWeight: 600,
    fontFamily: 'Montserrat',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIGGER]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 600,
    fontFamily: 'Montserrat',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIG]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 14,
      [SCREEN_SIZE.MEDIUM]: 14,
      [SCREEN_SIZE.SMALL]: 12
    },
    fontWeight: 400,
    fontFamily: 'Montserrat',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.TINY]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 12,
      [SCREEN_SIZE.MEDIUM]: 12,
      [SCREEN_SIZE.SMALL]: 10
    },
    fontWeight: 400,
    fontFamily: 'Montserrat',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.NORMAL]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 400,
    fontFamily: 'Roboto Slab',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  }
};

const palette$3 = {
  colors: colors$3,
  fonts: fonts$3,
  fontSizeMap: fontSizeMap$3
};

const configuration$4 = configurationBuilder().overrideColor('onTopCard', 'overlayColor', 'black').overrideColor('editionsMenu', 'menuBackgroundColor', 'black').overrideColor('footer', 'backgroundColor', 'darkGrey').overrideColor('footer', 'separatorColor', 'primary').overrideColor('secondaryHeader', 'backgroundColor', 'darkGrey').overrideColor('moreLinks', 'menuBackgroundColor', 'darkGrey').overrideColor('bottomFooterBar', 'backgroundColor', 'black').overrideColor('editionsMenu', 'hoverColor', 'primary').overrideColor('menuLinks', 'backgroundColor', 'black').overrideNumber('onTopCard', 'borderRadius', 0).overrideBoolean('onTopCard', 'showAuthorInLargeScreen', true).overrideBoolean('onTopCard', 'showAuthorInMediumScreen', true).overrideBoolean('onTopCard', 'showAuthorInSmallScreen', true).overrideBoolean('onTopCard', 'showDateInLargeScreen', true).overrideBoolean('onTopCard', 'showDateInMediumScreen', true).overrideBoolean('onTopCard', 'showDateInSmallScreen', true).overrideNumber('verticalCard', 'borderRadius', 0).overrideBoolean('verticalCard', 'showAuthorInLargeScreen', true).overrideBoolean('verticalCard', 'showAuthorInMediumScreen', true).overrideBoolean('verticalCard', 'showAuthorInSmallScreen', true).overrideBoolean('verticalCard', 'showDateInLargeScreen', true).overrideBoolean('verticalCard', 'showDateInMediumScreen', true).overrideBoolean('verticalCard', 'showDateInSmallScreen', true).overrideNumber('horizontalCard', 'borderRadius', 0).overrideBoolean('horizontalCard', 'showAuthorInLargeScreen', true).overrideBoolean('horizontalCard', 'showAuthorInMediumScreen', true).overrideBoolean('horizontalCard', 'showAuthorInSmallScreen', true).overrideBoolean('horizontalCard', 'showDateInLargeScreen', true).overrideBoolean('horizontalCard', 'showDateInMediumScreen', true).overrideBoolean('horizontalCard', 'showDateInSmallScreen', true).overrideNumber('ctaButton', 'borderRadius', 0).overrideNumber('list', 'borderRadius', 0).overrideNumber('listWithHeading', 'borderRadius', 0).overrideBoolean('sixSix', 'showDescriptionInMediumScreen', true).overrideBoolean('sixSix', 'showDescriptionInLargeScreen', true).overrideColor('button', 'backgroundColorNormal', COLORS.PRIMARY).overrideColor('button', 'textColorNormal', COLORS.WHITE).overrideNumber('button', 'borderRadius', 0).overrideNumber('button', 'borderWidthNormal', 0).overrideBoxShadow('button', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('button', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.HIGH).overrideBoxShadow('button', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoolean('sectionHeader', 'showBorderTop', true).overrideBoolean('sectionHeader', 'showArrow', true).overrideColor('sectionHeader', 'titleColor', 'black').overrideColor('sectionHeader', 'arrowColor', 'black').overrideNumber('sectionHeader', 'largeHorizontalGap', 0.5).overrideNumber('sectionHeader', 'mediumHorizontalGap', 0.5).overrideNumber('sectionHeader', 'smallHorizontalGap', 0.5).build();

const colors$4 = {
  [COLORS.PRIMARY]: '#DC2330',
  [COLORS.SECONDARY]: '#71CDDD',
  [COLORS.DARK_GREY]: '#212121',
  [COLORS.GREY]: '#A1A1A1',
  [COLORS.LIGHT_GREY]: '#F3F3F3',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const fonts$4 = [{
  provider: 'google',
  family: 'Oswald',
  variants: ['400', '600', '700']
}, {
  provider: 'google',
  family: 'Barlow',
  variants: ['400', '600', '700']
}];

const fontSizeMap$4 = {
  [TYPOGRAPHY_SIZE.GIGANTIC]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 40,
      [SCREEN_SIZE.MEDIUM]: 32,
      [SCREEN_SIZE.SMALL]: 24
    },
    fontWeight: 700,
    fontFamily: 'Oswald',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.HUGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 32,
      [SCREEN_SIZE.MEDIUM]: 24,
      [SCREEN_SIZE.SMALL]: 20
    },
    fontWeight: 600,
    fontFamily: 'Oswald',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.LARGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 20,
      [SCREEN_SIZE.MEDIUM]: 20,
      [SCREEN_SIZE.SMALL]: 16
    },
    fontWeight: 400,
    fontFamily: 'Oswald',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIGGER]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 400,
    fontFamily: 'Oswald',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIG]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 14,
      [SCREEN_SIZE.MEDIUM]: 14,
      [SCREEN_SIZE.SMALL]: 12
    },
    fontWeight: 400,
    fontFamily: 'Oswald',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.TINY]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 12,
      [SCREEN_SIZE.MEDIUM]: 12,
      [SCREEN_SIZE.SMALL]: 10
    },
    fontWeight: 400,
    fontFamily: 'Oswald',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.NORMAL]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 400,
    fontFamily: 'Barlow',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  }
};

const palette$4 = {
  colors: colors$4,
  fonts: fonts$4,
  fontSizeMap: fontSizeMap$4
};

const configuration$5 = configurationBuilder().overrideNumber('onTopCard', 'borderWidthTypeNormal', 0).overrideNumber('onTopCard', 'borderWidthTypeHover', 2).overrideNumber('onTopCard', 'borderWidthTypeActive', 0).overrideColor('onTopCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideNumber('verticalCard', 'borderWidthTypeNormal', 0).overrideNumber('verticalCard', 'borderWidthTypeHover', 2).overrideNumber('verticalCard', 'borderWidthTypeActive', 0).overrideColor('verticalCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideNumber('horizontalCard', 'borderWidthTypeNormal', 0).overrideNumber('horizontalCard', 'borderWidthTypeHover', 2).overrideNumber('horizontalCard', 'borderWidthTypeActive', 0).overrideColor('horizontalCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideColor('decorationLine', 'cardDecorationColor', COLORS.WHITE).overrideColor('verticalCard', 'cardTextColorTypeHover', COLORS.BLACK).overrideColor('horizontalCard', 'cardTextColorTypeHover', COLORS.BLACK).overrideBoxShadow('onTopCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('onTopCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('onTopCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('verticalCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('verticalCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('verticalCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('horizontalCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('horizontalCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('horizontalCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('listWithHeading', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('listWithHeading', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('listWithHeading', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('list', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('list', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('list', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoolean('onTopCard', 'showDateInLargeScreen', true).overrideBoolean('onTopCard', 'showDateInMediumScreen', true).overrideBoolean('onTopCard', 'showDateInSmallScreen', true).overrideBoolean('verticalCard', 'showDateInLargeScreen', true).overrideBoolean('verticalCard', 'showDateInMediumScreen', true).overrideBoolean('verticalCard', 'showDateInSmallScreen', true).overrideBoolean('horizontalCard', 'showDateInLargeScreen', true).overrideBoolean('horizontalCard', 'showDateInMediumScreen', true).overrideBoolean('horizontalCard', 'showDateInSmallScreen', true).overrideBoolean('sixSix', 'showDescriptionInMediumScreen', true).overrideBoolean('sixSix', 'showDescriptionInLargeScreen', true).overrideColor('button', 'backgroundColorNormal', COLORS.PRIMARY).overrideColor('button', 'backgroundColorHover', COLORS.WHITE).overrideColor('button', 'textColorNormal', COLORS.WHITE).overrideColor('button', 'textColorHover', COLORS.PRIMARY).overrideNumber('button', 'borderWidthNormal', 0).overrideNumber('button', 'borderWidthHover', 2).overrideColor('button', 'borderColorHover', COLORS.PRIMARY).build();

const colors$5 = {
  [COLORS.PRIMARY]: '#75CEDC',
  [COLORS.SECONDARY]: '#1B1B1B',
  [COLORS.DARK_GREY]: '#444444',
  [COLORS.GREY]: '#A1A1A1',
  [COLORS.LIGHT_GREY]: '#F3F3F3',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const fonts$5 = [{
  provider: 'custom',
  family: 'itc-avant-garde-gothic-pro',
  variants: ['300', '500', '700'],
  stylesheetUrl: 'https://use.typekit.net/mrl0ift.css'
}, {
  provider: 'custom',
  family: 'europa',
  variants: ['400', '500', '700'],
  stylesheetUrl: 'https://use.typekit.net/cew3eqg.css'
}];

const fontSizeMap$5 = {
  [TYPOGRAPHY_SIZE.GIGANTIC]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 40,
      [SCREEN_SIZE.MEDIUM]: 32,
      [SCREEN_SIZE.SMALL]: 24
    },
    fontWeight: 500,
    fontFamily: 'itc-avant-garde-gothic-pro',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.HUGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 32,
      [SCREEN_SIZE.MEDIUM]: 24,
      [SCREEN_SIZE.SMALL]: 20
    },
    fontWeight: 500,
    fontFamily: 'itc-avant-garde-gothic-pro',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.LARGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 20,
      [SCREEN_SIZE.MEDIUM]: 20,
      [SCREEN_SIZE.SMALL]: 16
    },
    fontWeight: 500,
    fontFamily: 'itc-avant-garde-gothic-pro',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIGGER]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 300,
    fontFamily: 'itc-avant-garde-gothic-pro',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIG]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 14,
      [SCREEN_SIZE.MEDIUM]: 14,
      [SCREEN_SIZE.SMALL]: 12
    },
    fontWeight: 300,
    fontFamily: 'itc-avant-garde-gothic-pro',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.TINY]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 12,
      [SCREEN_SIZE.MEDIUM]: 12,
      [SCREEN_SIZE.SMALL]: 10
    },
    fontWeight: 300,
    fontFamily: 'itc-avant-garde-gothic-pro',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.NORMAL]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 400,
    fontFamily: 'europa',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  }
};

const palette$5 = {
  colors: colors$5,
  fonts: fonts$5,
  fontSizeMap: fontSizeMap$5
};

const configuration$6 = configurationBuilder().overrideColor('onTopCard', 'overlayColor', 'black').overrideColor('editionsMenu', 'menuBackgroundColor', 'black').overrideColor('footer', 'backgroundColor', 'darkGrey').overrideColor('footer', 'separatorColor', 'primary').overrideColor('primaryHeader', 'backgroundColor', 'darkGrey').overrideColor('secondaryHeader', 'backgroundColor', 'primary').overrideColor('secondaryLink', 'hoverStateColor', 'darkGrey').overrideColor('secondaryLink', 'activeStateColor', 'darkGrey').overrideColor('moreLinks', 'menuBackgroundColor', 'primary').overrideColor('moreLinks', 'hoverColor', 'darkGrey').overrideColor('moreLinks', 'activeColor', 'darkGrey').overrideColor('bottomFooterBar', 'backgroundColor', 'black').overrideColor('editionsMenu', 'hoverColor', 'primary').overrideColor('menuLinks', 'backgroundColor', 'black').overrideColor('listItem', 'borderColor', 'primary').overrideNumber('onTopCard', 'borderRadius', 0).overrideNumber('verticalCard', 'borderRadius', 0).overrideNumber('horizontalCard', 'borderRadius', 0).overrideNumber('ctaButton', 'borderRadius', 0).overrideNumber('list', 'borderRadius', 0).overrideNumber('listWithHeading', 'borderRadius', 0).overrideColor('button', 'backgroundColorNormal', COLORS.PRIMARY).overrideColor('button', 'textColorNormal', COLORS.WHITE).overrideNumber('button', 'borderRadius', 0).overrideNumber('button', 'borderWidthNormal', 0).overrideBoxShadow('button', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('button', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.HIGH).overrideBoxShadow('button', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.LOW).build();

const colors$6 = {
  [COLORS.PRIMARY]: '#BDA55C',
  [COLORS.SECONDARY]: '#1F1B1B',
  [COLORS.DARK_GREY]: '#212121',
  [COLORS.GREY]: '#9E9E9E',
  [COLORS.LIGHT_GREY]: '#F3F3F3',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const fonts$6 = [{
  provider: 'custom',
  family: 'kulturista-web',
  variants: ['600', '700'],
  stylesheetUrl: 'https://use.typekit.net/jps0ikq.css'
}, {
  provider: 'google',
  family: 'Open Sans',
  variants: ['400']
}];

const fontSizeMap$6 = {
  [TYPOGRAPHY_SIZE.GIGANTIC]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 40,
      [SCREEN_SIZE.MEDIUM]: 32,
      [SCREEN_SIZE.SMALL]: 24
    },
    fontWeight: 700,
    fontFamily: 'kulturista-web',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.HUGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 32,
      [SCREEN_SIZE.MEDIUM]: 24,
      [SCREEN_SIZE.SMALL]: 20
    },
    fontWeight: 700,
    fontFamily: 'kulturista-web',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.LARGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 20,
      [SCREEN_SIZE.MEDIUM]: 20,
      [SCREEN_SIZE.SMALL]: 16
    },
    fontWeight: 600,
    fontFamily: 'kulturista-web',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIGGER]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 600,
    fontFamily: 'kulturista-web',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIG]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 14,
      [SCREEN_SIZE.MEDIUM]: 14,
      [SCREEN_SIZE.SMALL]: 12
    },
    fontWeight: 400,
    fontFamily: 'kulturista-web',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.TINY]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 12,
      [SCREEN_SIZE.MEDIUM]: 12,
      [SCREEN_SIZE.SMALL]: 10
    },
    fontWeight: 400,
    fontFamily: 'kulturista-web',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.NORMAL]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 400,
    fontFamily: 'Open Sans',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  }
};

const palette$6 = {
  colors: colors$6,
  fonts: fonts$6,
  fontSizeMap: fontSizeMap$6
};

const configuration$7 = configurationBuilder().overrideColor('main', 'backgroundColor', COLORS.WHITE).overrideColor('footer', 'backgroundColor', COLORS.BLACK).overrideColor('footer', 'separatorColor', COLORS.PRIMARY).overrideColor('moreLinks', 'menuBackgroundColor', COLORS.BLACK).overrideColor('bottomFooterBar', 'backgroundColor', COLORS.BLACK).overrideColor('onTopCard', 'overlayColor', COLORS.BLACK).overrideNumber('onTopCard', 'borderRadius', 0).overrideBoolean('onTopCard', 'showAuthorInLargeScreen', true).overrideBoolean('onTopCard', 'showAuthorInMediumScreen', true).overrideBoolean('onTopCard', 'showAuthorInSmallScreen', true).overrideBoolean('onTopCard', 'showDateInLargeScreen', true).overrideBoolean('onTopCard', 'showDateInMediumScreen', true).overrideBoolean('onTopCard', 'showDateInSmallScreen', true).overrideColor('onTopCard', 'dateColor', COLORS.WHITE).overrideNumber('verticalCard', 'borderRadius', 0).overrideBoolean('verticalCard', 'showAuthorInLargeScreen', true).overrideBoolean('verticalCard', 'showAuthorInMediumScreen', true).overrideBoolean('verticalCard', 'showAuthorInSmallScreen', true).overrideBoolean('verticalCard', 'showDateInLargeScreen', true).overrideBoolean('verticalCard', 'showDateInMediumScreen', true).overrideBoolean('verticalCard', 'showDateInSmallScreen', true).overrideNumber('horizontalCard', 'borderRadius', 0).overrideBoolean('horizontalCard', 'showAuthorInLargeScreen', true).overrideBoolean('horizontalCard', 'showAuthorInMediumScreen', true).overrideBoolean('horizontalCard', 'showAuthorInSmallScreen', true).overrideBoolean('horizontalCard', 'showDateInLargeScreen', true).overrideBoolean('horizontalCard', 'showDateInMediumScreen', true).overrideBoolean('horizontalCard', 'showDateInSmallScreen', true).overrideColor('horizontalCard', 'authorColor', COLORS.GREY).overrideColor('verticalCard', 'authorColor', COLORS.GREY).overrideColor('onTopCard', 'authorColor', COLORS.LIGHT_GREY).overrideBoxShadow('onTopCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('onTopCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('onTopCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('verticalCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('verticalCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('verticalCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('horizontalCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('horizontalCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.NONE).overrideBoxShadow('horizontalCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.NONE).overrideNumber('onTopCard', 'borderWidthTypeNormal', 2).overrideNumber('onTopCard', 'borderWidthTypeHover', 2).overrideNumber('onTopCard', 'borderWidthTypeActive', 2).overrideNumber('verticalCard', 'borderWidthTypeNormal', 2).overrideNumber('verticalCard', 'borderWidthTypeHover', 2).overrideNumber('horizontalCard', 'borderWidthTypeNormal', 2).overrideNumber('horizontalCard', 'borderWidthTypeHover', 2).overrideNumber('horizontalCard', 'borderWidthTypeActive', 2).overrideColor('horizontalCard', 'borderColorTypeNormal', COLORS.LIGHT_GREY).overrideColor('horizontalCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideColor('horizontalCard', 'borderColorTypeActive', COLORS.LIGHT_GREY).overrideColor('verticalCard', 'borderColorTypeNormal', COLORS.LIGHT_GREY).overrideColor('verticalCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideColor('verticalCard', 'borderColorTypeActive', COLORS.LIGHT_GREY).overrideColor('onTopCard', 'borderColorTypeNormal', COLORS.LIGHT_GREY).overrideColor('onTopCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideColor('onTopCard', 'borderColorTypeActive', COLORS.LIGHT_GREY).overrideColor('decorationLine', 'cardDecorationColor', COLORS.WHITE).overrideNumber('ctaButton', 'borderRadius', 0).overrideNumber('list', 'borderRadius', 0).overrideNumber('listWithHeading', 'borderRadius', 0).overrideColor('button', 'backgroundColorNormal', COLORS.PRIMARY).overrideColor('button', 'textColorNormal', COLORS.WHITE).overrideNumber('button', 'borderRadius', 0).overrideNumber('button', 'borderWidthNormal', 0).overrideBoxShadow('button', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('button', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.HIGH).overrideBoxShadow('button', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.LOW).overrideColor('sectionHeader', 'titleColor', COLORS.SECONDARY).overrideColor('sectionHeader', 'titleBackgroundColor', COLORS.WHITE).overrideBoolean('sectionHeader', 'showMiddleHorizontalLine', true).overrideBoolean('sectionHeader', 'showArrow', true).overrideColor('sectionHeader', 'arrowColor', COLORS.SECONDARY).overrideColor('sectionHeader', 'middleHorizontalLineColor', COLORS.LIGHT_GREY).overrideNumber('sectionHeader', 'largeVerticalGap', 1).overrideNumber('sectionHeader', 'mediumVerticalGap', 1).overrideNumber('sectionHeader', 'smallVerticalGap', 0.5).overrideBoolean('tenHCForOneThird', 'showDescriptionInMediumScreen', true).overrideTypography('threeThreeVC', 'metadataFontSizeLarge', TYPOGRAPHY_SIZE.BIG).overrideTypography('threeThreeVC', 'metadataFontSizeMedium', TYPOGRAPHY_SIZE.BIG).overrideTypography('threeThreeVC', 'metadataFontSizeSmall', TYPOGRAPHY_SIZE.BIG).overrideTypography('threeThreeVC', 'titleFontSizeLarge', TYPOGRAPHY_SIZE.BIGGER).overrideTypography('threeThreeVC', 'titleFontSizeMedium', TYPOGRAPHY_SIZE.BIGGER).overrideTypography('threeThreeVC', 'titleFontSizeSmall', TYPOGRAPHY_SIZE.BIGGER).overrideBoolean('oneOTCThreeHC', 'showDescriptionInMediumScreen', true).overrideTypography('oneOTCThreeHC', 'metadataFontSizeLarge', TYPOGRAPHY_SIZE.BIG).overrideTypography('oneOTCThreeHC', 'metadataFontSizeMedium', TYPOGRAPHY_SIZE.BIG).overrideTypography('oneOTCThreeHC', 'metadataFontSizeSmall', TYPOGRAPHY_SIZE.BIG).overrideTypography('oneOTCThreeHC', 'OTCTitleFontSizeSmall', TYPOGRAPHY_SIZE.BIGGER).overrideColor('oneOTCThreeHC', 'authorColor', COLORS.PRIMARY).overrideNumber('oneOTCThreeHC', 'insideCardSmallHorizontalGap', 0.5).overrideTypography('oneTwoOnTopFullWidth', 'mainCardTitleFontSizeLarge', TYPOGRAPHY_SIZE.LARGE).overrideTypography('oneTwoOnTopFullWidth', 'mainCardTitleFontSizeMedium', TYPOGRAPHY_SIZE.LARGE).overrideTypography('oneTwoOnTopFullWidth', 'mainCardTitleFontSizeSmall', TYPOGRAPHY_SIZE.LARGE).overrideTypography('oneTwoOnTopFullWidth', 'secondaryCardsTitleFontSizeLarge', TYPOGRAPHY_SIZE.BIGGER).overrideTypography('oneTwoOnTopFullWidth', 'secondaryCardsTitleFontSizeMedium', TYPOGRAPHY_SIZE.BIGGER).overrideTypography('oneTwoOnTopFullWidth', 'secondaryCardsMetadataFontSizeLarge', TYPOGRAPHY_SIZE.BIG).overrideTypography('oneTwoOnTopFullWidth', 'secondaryCardsMetadataFontSizeMedium', TYPOGRAPHY_SIZE.BIG).overrideTypography('oneTwoOnTopFullWidth', 'secondaryCardsMetadataFontSizeSmall', TYPOGRAPHY_SIZE.BIG).overrideColor('oneTwoOnTopFullWidth', 'authorColor', COLORS.PRIMARY).overrideNumber('oneTwoOnTopFullWidth', 'insideCardSmallHorizontalGap', 0.5).overrideRatio('sixHCForTwoThirds', 'aspectRatioSmall', {
  x: 1,
  y: 1
}).overrideColor('headerWithSubMenus', 'firstRowBackgroundColor', COLORS.BLACK).overrideColor('headerWithSubMenus', 'secondRowBackgroundColor', COLORS.BLACK).build();

const colors$7 = {
  [COLORS.PRIMARY]: '#FE5000',
  [COLORS.SECONDARY]: '#141414',
  [COLORS.DARK_GREY]: '#181818',
  [COLORS.GREY]: '#888888',
  [COLORS.LIGHT_GREY]: '#F4F4F4',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const fonts$7 = [{
  provider: 'custom',
  family: 'poppins',
  variants: ['300', '400', '500', '600'],
  stylesheetUrl: 'https://use.typekit.net/ywx1kgy.css'
}];

const fontSizeMap$7 = {
  [TYPOGRAPHY_SIZE.GIGANTIC]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 40,
      [SCREEN_SIZE.MEDIUM]: 32,
      [SCREEN_SIZE.SMALL]: 24
    },
    fontWeight: 600,
    fontFamily: 'poppins',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.HUGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 32,
      [SCREEN_SIZE.MEDIUM]: 24,
      [SCREEN_SIZE.SMALL]: 20
    },
    fontWeight: 600,
    fontFamily: 'poppins',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.LARGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 20,
      [SCREEN_SIZE.MEDIUM]: 20,
      [SCREEN_SIZE.SMALL]: 16
    },
    fontWeight: 500,
    fontFamily: 'poppins',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIGGER]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 500,
    fontFamily: 'poppins',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIG]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 14,
      [SCREEN_SIZE.MEDIUM]: 14,
      [SCREEN_SIZE.SMALL]: 12
    },
    fontWeight: 400,
    fontFamily: 'poppins',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.TINY]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 12,
      [SCREEN_SIZE.MEDIUM]: 12,
      [SCREEN_SIZE.SMALL]: 10
    },
    fontWeight: 400,
    fontFamily: 'poppins',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.NORMAL]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 300,
    fontFamily: 'poppins',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  }
};

const palette$7 = {
  colors: colors$7,
  fonts: fonts$7,
  fontSizeMap: fontSizeMap$7
};

const configuration$8 = configurationBuilder().overrideNumber('onTopCard', 'borderWidthTypeNormal', 0).overrideNumber('onTopCard', 'borderWidthTypeHover', 1).overrideNumber('onTopCard', 'borderWidthTypeActive', 1).overrideNumber('verticalCard', 'borderWidthTypeNormal', 0).overrideNumber('verticalCard', 'borderWidthTypeHover', 1).overrideNumber('verticalCard', 'borderWidthTypeActive', 1).overrideNumber('horizontalCard', 'borderWidthTypeNormal', 0).overrideNumber('horizontalCard', 'borderWidthTypeHover', 1).overrideNumber('horizontalCard', 'borderWidthTypeActive', 1).overrideNumber('list', 'borderWidth', 2).overrideNumber('listWithHeading', 'borderWidth', 2).overrideColor('list', 'borderColor', COLORS.LIGHT_GREY).overrideColor('listWithHeading', 'borderColor', COLORS.LIGHT_GREY).overrideColor('horizontalCard', 'borderColorTypeNormal', COLORS.LIGHT_GREY).overrideColor('horizontalCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideColor('horizontalCard', 'borderColorTypeActive', COLORS.SECONDARY).overrideColor('verticalCard', 'borderColorTypeNormal', COLORS.LIGHT_GREY).overrideColor('verticalCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideColor('verticalCard', 'borderColorTypeActive', COLORS.SECONDARY).overrideColor('onTopCard', 'borderColorTypeNormal', COLORS.LIGHT_GREY).overrideColor('onTopCard', 'borderColorTypeHover', COLORS.PRIMARY).overrideColor('onTopCard', 'borderColorTypeActive', COLORS.SECONDARY).overrideColor('decorationLine', 'cardDecorationColor', COLORS.WHITE).overrideColor('main', 'backgroundColor', COLORS.LIGHT_GREY).overrideColor('secondaryHeader', 'backgroundColor', COLORS.DARK_GREY).overrideColor('onTopCard', 'overlayColor', COLORS.BLACK).overrideColor('verticalCard', 'cardTextColorTypeHover', COLORS.BLACK).overrideColor('horizontalCard', 'cardTextColorTypeHover', COLORS.BLACK).overrideColor('footer', 'backgroundColor', COLORS.BLACK).overrideColor('horizontalCard', 'cardTextColorTypeActive', COLORS.DARK_GREY).overrideColor('moreLinks', 'menuBackgroundColor', COLORS.DARK_GREY).overrideColor('editionsMenu', 'menuBackgroundColor', COLORS.BLACK).overrideColor('menuLinks', 'backgroundColor', COLORS.BLACK).overrideBoxShadow('onTopCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('onTopCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('onTopCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('verticalCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('verticalCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('verticalCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('horizontalCard', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('horizontalCard', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('horizontalCard', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('listWithHeading', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('listWithHeading', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('listWithHeading', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('list', 'boxShadowTypeNormal', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('list', 'boxShadowTypeHover', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoxShadow('list', 'boxShadowTypeActive', BOX_SHADOW_TYPES_VALUES.LOW).overrideBoolean('onTopCard', 'showAuthorInLargeScreen', true).overrideBoolean('onTopCard', 'showAuthorInMediumScreen', true).overrideBoolean('onTopCard', 'showAuthorInSmallScreen', true).overrideBoolean('horizontalCard', 'showAuthorInLargeScreen', true).overrideBoolean('horizontalCard', 'showAuthorInMediumScreen', true).overrideBoolean('horizontalCard', 'showAuthorInSmallScreen', true).overrideBoolean('verticalCard', 'showAuthorInLargeScreen', true).overrideBoolean('verticalCard', 'showAuthorInMediumScreen', true).overrideBoolean('verticalCard', 'showAuthorInSmallScreen', true).overrideBoolean('sixSix', 'showDescriptionInMediumScreen', true).overrideBoolean('sixSix', 'showDescriptionInLargeScreen', true).overrideNumber('sectionHeader', 'largeVerticalGap', 1).overrideNumber('sectionHeader', 'mediumVerticalGap', 1).overrideNumber('sectionHeader', 'smallVerticalGap', 0.5).build();

const colors$8 = {
  [COLORS.PRIMARY]: '#EC028C',
  [COLORS.SECONDARY]: '#F7941F',
  [COLORS.DARK_GREY]: '#212121',
  [COLORS.GREY]: '#AAAAAA',
  [COLORS.LIGHT_GREY]: '#FAFAFA',
  [COLORS.BLACK]: '#000000',
  [COLORS.WHITE]: '#FFFFFF'
};

const fonts$8 = [{
  provider: 'google',
  family: 'Comfortaa',
  variants: ['500', '600', '700']
}, {
  provider: 'google',
  family: 'Heebo',
  variants: ['400']
}];

const fontSizeMap$8 = {
  [TYPOGRAPHY_SIZE.GIGANTIC]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 40,
      [SCREEN_SIZE.MEDIUM]: 32,
      [SCREEN_SIZE.SMALL]: 24
    },
    fontWeight: 700,
    fontFamily: 'Comfortaa',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.HUGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 32,
      [SCREEN_SIZE.MEDIUM]: 24,
      [SCREEN_SIZE.SMALL]: 20
    },
    fontWeight: 700,
    fontFamily: 'Comfortaa',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.LARGE]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 20,
      [SCREEN_SIZE.MEDIUM]: 20,
      [SCREEN_SIZE.SMALL]: 16
    },
    fontWeight: 600,
    fontFamily: 'Comfortaa',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIGGER]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 600,
    fontFamily: 'Comfortaa',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.BIG]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 14,
      [SCREEN_SIZE.MEDIUM]: 14,
      [SCREEN_SIZE.SMALL]: 12
    },
    fontWeight: 500,
    fontFamily: 'Comfortaa',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.TINY]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 12,
      [SCREEN_SIZE.MEDIUM]: 12,
      [SCREEN_SIZE.SMALL]: 10
    },
    fontWeight: 500,
    fontFamily: 'Comfortaa',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  },
  [TYPOGRAPHY_SIZE.NORMAL]: {
    screenSizes: {
      [SCREEN_SIZE.LARGE]: 16,
      [SCREEN_SIZE.MEDIUM]: 16,
      [SCREEN_SIZE.SMALL]: 14
    },
    fontWeight: 400,
    fontFamily: 'Heebo',
    defaultFontFamily: '-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
  }
};

const palette$8 = {
  colors: colors$8,
  fonts: fonts$8,
  fontSizeMap: fontSizeMap$8
};

const themeByKey = {
  orangeAndBlack: {
    configuration: configuration$1,
    palette: palette$1
  },
  blueAndGrey: {
    configuration: configuration,
    palette: palette
  },
  purpleAndViolet: {
    configuration: configuration$2,
    palette: palette$2
  },
  thebiglead: {
    configuration: configuration$3,
    palette: palette$3
  },
  dbltap: {
    configuration: configuration$4,
    palette: palette$4
  },
  floor8: {
    configuration: configuration$5,
    palette: palette$5
  },
  laVida: {
    configuration: configuration$6,
    palette: palette$6
  },
  '90min': {
    configuration: configuration$7,
    palette: palette$7
  },
  theBluntness: {
    configuration: configuration$8,
    palette: palette$8
  }
};

const createTheme = themeKey => {
  if (!themeByKey[themeKey]) {
    throw new Error(`${themeKey} is not a valid themeKey`);
  }

  const {
    configuration,
    palette
  } = themeByKey[themeKey];
  return {
    palette,
    configuration
  };
};

const getThemeByKey = themeKey => {
  return createTheme(themeKey);
};

export { COLORS, CONFIGURATION_TYPES, getThemeByKey };
//# sourceMappingURL=index.bundle.esm.js.map
